import { useScript } from "@artists/devkit"
import { CloseAction, useSnackbar } from "@artists/uikit"
import { Button } from "@mui/material"
import { useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"

import { getENV } from "../../../../../@common"
import { useAuth } from "../../../../api"

export const useRecaptcha = (onSubmit: (token?: string) => void) => {
	const [t] = useTranslation()
	const isRendered = useRef(false)
	const { show, close } = useSnackbar()

	const [isLoaded] = useScript("https://www.google.com/recaptcha/api.js", {
		nonce: IS_CLIENT && window.NONCE,
	})

	const { authorized, isDataReceived } = useAuth()

	useEffect(() => {
		if (!isLoaded || !window.grecaptcha) return

		const onError = (reason: string) => () => {
			show(reason, {
				action: (
					<>
						<Button
							sx={{
								textTransform: "none",
								textDecoration: "underline",
								color: "white",
							}}
							onClick={() => {
								grecaptcha.reset()
								close()
							}}
						>
							{t`recaptcha.tryAgain`}
						</Button>

						<CloseAction />
					</>
				),
				variant: "error",
				persist: true,
			})
		}

		if (!authorized && isDataReceived && !isRendered.current) {
			window.grecaptcha.ready(() => {
				window.grecaptcha.render("g-recaptcha", {
					sitekey: getENV("GOOGLE_RECAPTCHA_KEY"),
					size: "invisible",
					callback: onSubmit,
					"error-callback": onError(t`recaptcha.error`),
					"expired-callback": onError(t`recaptcha.expired`),
				})
			})
			isRendered.current = true
		}
	}, [authorized, isDataReceived, onSubmit, show, close, t, isLoaded])
}
